import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { AuthProvider } from "./auth/AuthContext";
// Self-hosted Inter variable face (weight axis only). Replaces a third-party
// font request and renders the 650 weight the Relay spec calls for.
import "@fontsource-variable/inter/wght.css";
import "@userabuser/app-ui-kanban/style.css";
import "./index.css";

const container = document.getElementById("root");
if (!container) throw new Error("Root container #root not found");

ReactDOM.createRoot(container).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
